import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useLanguage } from "../../providers/language_provider";
import { Button } from "../common/Button";

const ReviewCard = ({ name, review, stars: rating, rol }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const cardVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  const stars = Array.from({ length: rating }, (_, i) => (
    <motion.svg
      key={i}
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: i * 0.1, duration: 0.3 }}
      className="w-5 h-5 text-yellow-400 hover:text-yellow-300 transition-colors"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </motion.svg>
  ));

  return (
    <motion.div
      ref={ref}
      variants={cardVariants}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      whileHover={{ scale: 1.02 }}
      className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-xl p-8 shadow-xl hover:shadow-primary-500/20 transition-all duration-300 border border-gray-800 hover:border-primary-500/30"
    >
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-1">{stars}</div>
        <span className="text-gray-400 text-sm font-medium">{rol}</span>
      </div>
      <p className="text-gray-300 mb-6 leading-relaxed">{review}</p>
      <motion.p
        className="text-primary-500 font-semibold text-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        {name}
      </motion.p>
    </motion.div>
  );
};

export function Reviews({ reviews, isAll }) {
  const { content } = useLanguage();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section
      className={`py-32 ${
        isAll ? "bg-gradient-to-b from-black via-gray-900 to-black" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30, scale: 0.95 }}
          animate={
            inView
              ? { opacity: 1, y: 0, scale: 1 }
              : { opacity: 0, y: 30, scale: 0.95 }
          }
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-tight">
            Reseñas
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review) => (
            <ReviewCard {...review} />
          ))}
        </div>

        {isAll && (
          <div className="text-center mt-12">
            <Button
              text={content.seeMoreReviews}
              to="/reviews"
              variant="outline"
              size="lg"
            />
          </div>
        )}
      </div>
    </section>
  );
}
